export const calcNewTypeDeduction = (newTypeTotalAmount: number) => {
  if (newTypeTotalAmount < 20000) {
    return newTypeTotalAmount;
  } else if (newTypeTotalAmount <= 40000) {
    return Math.ceil(newTypeTotalAmount / 2 + 10000);
  } else if (newTypeTotalAmount <= 80000) {
    return Math.ceil(newTypeTotalAmount / 4 + 20000);
  } else {
    return 40000;
  }
};

export const calcOldTypeDeduction = (oldTypeTotalAmount: number) => {
  if (oldTypeTotalAmount < 25000) {
    return oldTypeTotalAmount;
  } else if (oldTypeTotalAmount <= 50000) {
    return Math.ceil(oldTypeTotalAmount / 2 + 12500);
  } else if (oldTypeTotalAmount <= 100000) {
    return Math.ceil(oldTypeTotalAmount / 4 + 25000);
  } else {
    return 50000;
  }
};

export const calcDeduction = (newTypeDeduction: number, oldTypeDeduction: number) => {
  if (oldTypeDeduction >= 50000) return 50000;
  if (oldTypeDeduction >= 40000) return oldTypeDeduction;

  const totalDeduction = oldTypeDeduction + newTypeDeduction;
  return oldTypeDeduction + newTypeDeduction >= 40000 ? 40000 : totalDeduction;
};

export const calcTotalDeduction = (
  generalLifeInsuranceDeduction: number,
  nursingMedicalInsuranceDeduction: number,
  individualAnnuityInsuranceDeduction: number
) => {
  const totalDeduction = generalLifeInsuranceDeduction + nursingMedicalInsuranceDeduction + individualAnnuityInsuranceDeduction;
  return totalDeduction <= 120000 ? totalDeduction : 120000;
};
